import statuses from '@/store/statuses';
import mutations from './mutations';
import actions from './actions';

const defaultState = () => {
  return {
    translationsList: {
      data: [],
      status: statuses.EMPTY,
    },
    translationCreateData: {
      data: [],
      status: statuses.EMPTY,
    },
    // translationUpdateData: {
    //   data: [],
    //   status: statuses.EMPTY,
    // },
    translationCreate: {
      data: [],
      status: statuses.EMPTY,
    },
    translationUpdate: {
      data: [],
      status: statuses.EMPTY,
    },
    translationDelete: {
      data: [],
      status: statuses.EMPTY,
    },
  };
};

const Translations = {
  namespaced: true,
  state: defaultState,
  getters: {
    // translationsList:         (state) => state.translationsList,
    translationCreateData:    (state) => state.translationCreateData,
    // translationUpdateData:    (state) => state.translationUpdateData,
    translationCreate:        (state) => state.translationCreate,
    translationUpdate:        (state) => state.translationUpdate,
  },
  mutations,
  actions,
};

export { Translations, defaultState };
